<template>
<div v-if="product">
    <form class="product" @submit.prevent="submit()">
      <div class="card" :class="{'bg-light': status == 'complete'}">
        <div class="card-body">
          <div class="row align-items-center">
            <div v-if="product.thumbnail" class="col-md-2">
              <img :src="product.thumbnail" class="img-fluid" alt="">
            </div>
            <div class="col-md">
              <h2>{{ product.name }}</h2>
              <p class="lead">
                {{ product.description }}
              </p>
            </div>
            <div v-if="product.price > 0" class="col-md-auto text-md-right">
              <span class="h2">{{ product.price | currency }}</span>
              <p v-if="product.shipping" class="lead">
                zzgl. Versandkosten
              </p>
            </div>
            <div v-else-if="product.price === 0" class="col-md-auto text-md-right">
              <span class="h2">kostenlos</span>
            </div>
          </div>
        </div>
        <div v-if="product.stock.status == 'instock'">
          <div v-if="product.fields.length > 0" class="card-body">
            <div v-for="field of product.fields" :key="field.id" class="form-group">
              <Field :field="field" :value="value[field.id]" :product="product" :state="status" :onChange="handleChange" />
            </div>
          </div>
          <div v-if="product.features.length > 0">
            <ul class="list-group list-group-flush">
              <li class="list-group-item" :class="{'list-group-item-success': isFeatureActive(feature), 'list-group-item-light': !isFeatureAvailable(feature)}" v-for="feature of product.features" :key="'feature' + feature.id">
                <div class="form-row" @click="handleFeatureClick(feature)">
                  <div class="col-auto">
                      <input type="checkbox" :checked="isFeatureActive(feature)" :disabled="!isFeatureAvailable(feature)">
                  </div>
                  <div class="col">
                      {{ feature.name }}<br>
                      <span class="text-muted">{{ feature.description }}</span>
                  </div>
                  <div v-if="isFeatureAvailable(feature)" class="col-auto">
                    + {{ feature.price | currency }}
                  </div>
                  <div v-else class="col-auto">
                    {{ feature.stock.info }}
                  </div>
                </div>
                <div v-if="isFeatureActive(feature)" class="">
                  <div v-for="featureField of feature.fields" :key="'feature-' + feature.id + '-field-' + featureField.id" class="form-group">
                    <Field :field="featureField" :value="featureValues[featureField.id]" :product="feature" :state="status" :onChange="handleChange" />
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div v-if="status == 'complete'">
            <div class="alert alert-primary m-0 text-center">
              <div v-if="product.type == 'event'" style="margin-bottom: 15px">
                <strong>Fast geschafft!</strong><br>
                Im letzten Schritt musst du nun noch per Bankeinzug bezahlen, damit deine Anmeldung abgeschlossen ist.<br>
                Erst dann ist die Anmeldung gültig und du erhältst eine Meldebestätigung per E-Mail!
              </div>
              <div v-else style="margin-bottom: 15px">
                {{ product.name }} wurde zum Warenkorb hinzugefügt.
              </div>
              
              <div v-if="product.type == 'event'">
                <p>
                  <a class="btn btn-primary" href="/warenkorb/">Ich möchte meine Anmeldung abschließen</a><br>
                </p>
                <a href="#" @click.prevent="startOver()">Ich möchte eine weitere Person anmelden</a>
              </div>
              <div v-else>
                <p>
                  <a class="btn btn-primary" href="/warenkorb/">Ich möchte meine Bestellung abschließen</a><br>
                </p>
                <a href="#" @click.prevent="status = 'idle'">Ich möchte weiter einkaufen</a>
              </div>
            </div>
          </div>
          <div v-else class="card-body">
            
            <div v-if="errors.length > 0" class="alert alert-danger mb-3">
              <div v-for="error of errors" :key="error">{{ error }}</div>
            </div>

            <p class="alert alert-warning text-center">
              <span v-if="product.type == 'event'">
                Du kannst deine Anmeldung im nächsten Schritt noch einmal überprüfen oder eine weitere Person eintragen.
              </span>
              <span v-else>
                Du kannst deine Bestellung im nächsten Schritt noch einmal überprüfen oder vorher weitere Produkte / Anmeldungen hinzufügen
              </span>
            </p>
            
            <button class="btn btn-block btn-secondary" :disabled="status == 'processing'">
              <span v-if="status == 'processing'">...</span>
              <span v-else-if="product.type == 'event'">Anmeldung abschließen</span>
              <span v-else>Produkt zum Warenkorb hinzufügen</span>
            </button>
          </div>
        </div>
        <div class="alert alert-secondary m-0 text-center lead" v-else>
          {{ product.stock.info }}
        </div>
      </div><!-- .card -->
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import Field from './Field.vue'

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default {
  name: 'ProductDetail',
  props: {
    productId: Number,
  },
  data: function() {
    return {
      product: null,
      value: {},
      featureValues: {},
      features: [],
      errors: [],
      status: 'idle',
      cartKey: null,
    }
  },
  mounted() {
    const productId = this.productId

    axios.get(process.env.VUE_APP_API_URL + '/products/' + productId).then(response => {
      this.product = response.data
    })

    this.cartKey = localStorage.getItem('lex_cart_key')
  },
  methods: {
    handleChange(val, product) {
      
      if (product.id === this.product.id) {
        this.value = Object.assign(this.value, val);
      } else {
        this.featureValues[product.id] = Object.assign(this.featureValues[product.id], val);
      }

      console.log(this.featureValues)
    },
    startOver() {
      this.status = 'idle'
      const keep = [
        'team',
        'street',
        'zip',
        'city',
        'email',
      ];

      for (const key in this.value) {
        if (keep.indexOf(key) > -1) continue;

        this.value[key] = ''
      }

      this.featureValues = {}
      this.features = []

    },
    handleFeatureClick(feature) {
      if (!this.isFeatureAvailable(feature))
        return
      
      if (this.isFeatureActive(feature)) {
        this.features.splice(this.features.indexOf(feature), 1)
        delete this.featureValues[feature.id]
      } else {
        this.features.push(feature)
        if (this.featureValues[feature.id] === undefined) this.featureValues[feature.id] = {
          product_id: feature.id,
        }
      }
    },
    isFeatureActive(feature) {
      return this.features.indexOf(feature) !== -1
    },
    isFeatureAvailable(feature) {
      return feature.stock.status === 'instock'
    },
    submit() {
      this.status = 'processing'
      this.errors = []

      var body = { product_id: this.productId }

      for (let key in this.value) {
        body[key] = this.value[key]
      }

      body['features'] = Object.values(this.featureValues)
      
      var url = process.env.VUE_APP_API_URL + '/cart'

      if (this.cartKey) {
        url += '/' + this.cartKey
      }
      
      axios.post(url, body, {
        withCredentials: true,
      }).then(response => {
        this.status = 'complete'
        this.cartKey = response.data.cart_key
        localStorage.setItem('lex_cart_key', this.cartKey);
      }).catch(error => {
        const data = error.response.data
        for (let key in data.errors) {
          const error = data.errors[key]
          this.errors = this.errors.concat(error)
        }
        this.status = 'idle'
      })
    }
  },
  components: {
    Field,
  }
}
</script>